import { useMemo } from 'react'
import { useRecoilValueLoadable } from 'recoil'
import { createDefaultMixContractInfo } from 'store/data/Contract'
import { createEmptyAssetMode } from 'store/data/Account'
import { useMatch } from 'react-router-dom'
import { RouteToBusinessLine } from 'constants/base'
import { createDefaultAIParams } from 'store/data/Strategy'

function useLodableValue(recoilValue: any, defaultData = []): any {
    const lodableData = useRecoilValueLoadable<any>(recoilValue)
    let handleDefaultData: any = defaultData
    switch (recoilValue.key) {
        case 'mix-strategy-info-state-lodable':
            handleDefaultData = createDefaultMixContractInfo()
            break
        case 'strategy-user-asset-mode-selector':
        case 'user-asset-mode-selector':
            handleDefaultData = createEmptyAssetMode()
            break
        case 'strategy-ai-data':
            handleDefaultData = createDefaultAIParams()
            break
    }
    const data = useMemo(() => {
        if (lodableData?.state === 'hasValue') {
            return lodableData?.contents
        }
        return handleDefaultData
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lodableData])
    return data
}
function useLodableValueByParams(recoilValue: any, defaultData = []): any {
    const urlMatch = useMatch('/:first/:line/:symbolId')
    const { symbolId, line } = urlMatch?.params || {}
    const businessLine = RouteToBusinessLine[line]
    const lodableData = useRecoilValueLoadable<any>(recoilValue({ symbolId, businessLine }))
    let handleDefaultData: any = defaultData
    switch (recoilValue.key) {
        case 'mix-strategy-info-state-lodable':
            handleDefaultData = createDefaultMixContractInfo()
            break
        case 'strategy-user-asset-mode-selector':
        case 'user-asset-mode-selector':
            handleDefaultData = createEmptyAssetMode()
            break
        default:
            break
    }
    const data = useMemo(() => {
        if (lodableData?.state === 'hasValue') {
            return lodableData?.contents
        }
        return handleDefaultData
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lodableData])
    return data
}
export { useLodableValueByParams, useLodableValue }
